import { Input, type InputProps as Props } from '@ps/web-shared-components';
import { allowedLength, serverFieldErrMsgWarning } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import { useForm } from 'react-final-form';

import useErrorHandling from '@swf/core/hooks/useErrorHandling';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import useDisableField from '../../../../../../hooks/useDisableField';

import styles from './InputSection.scss';

interface InputProps extends Props {
  checkDisabled?: boolean;
  length: number;
}

const InputSection: React.FC<InputProps> = ({
  id,
  length,
  placeholder,
  checkDisabled,
  ...props
}) => {
  const { error } = useWizardContext();
  const { removeError } = useErrorHandling();
  const disableField = useDisableField();
  const form = useForm();

  const handleChange = (id: string, e: React.ChangeEvent<HTMLInputElement>) => {
    switch (id) {
      case 'ssn1': {
        if (e.target.value.length == 3) {
          document.getElementById('ssn2')?.focus();
        }
        break;
      }
      case 'ssn2': {
        if (e.target.value.length == 2) {
          document.getElementById('ssn3')?.focus();
        }
        break;
      }
      default:
        break;
    }
  };

  return (
    <Input
      id={id}
      className={classNames(styles.ssnInput)}
      {...props}
      validators={[
        ...(props.validators || []),
        allowedLength([length]),
        serverFieldErrMsgWarning(error, () => error && removeError(error), form)
      ]}
      placeholder={placeholder}
      showValidationTick={false}
      {...(checkDisabled && { disabled: disableField(id) })}
      onChange={(e) => handleChange(id, e)}
      hideError
    />
  );
};

export default InputSection;
